import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'
import { Card } from '@mui/material'
import SEOAirlineFilter from './airline'
import SEODepartureTimingFilter from './departureTiming'
import SEOFilterHeader from './filterHeader'
import SEOPriceFilter from './price'
import SEOStopFilter from './stopFilter'

const SEOFilterWrapper = () => {
    return (
        <Card
            sx={{
                bgcolor: 'background.default',
                borderRadius: 1.5,
                border: 1,
                borderColor: 'grey.200',
                overflow: 'auto',
                boxShadow: 'none',
                // Hide scrollbar while maintaining scroll functionality
                '&::-webkit-scrollbar': {
                    display: 'none'
                },
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
            }}
        >
            <ErrorBoundaryWrapper identifier={`SEOFilterHeader-desktop-srp`} fallback={null}>
                <SEOFilterHeader />
            </ErrorBoundaryWrapper>
            {/* Stops Filter */}
            <ErrorBoundaryWrapper identifier={`stopsFilter-desktop-SEO-srp`} fallback={null}>
                <SEOStopFilter />
            </ErrorBoundaryWrapper>

            {/* Flight Timings Filter */}
            <ErrorBoundaryWrapper identifier={`flightTimingsFilter-desktop-SEO-srp`} fallback={null}>
                <SEODepartureTimingFilter />
            </ErrorBoundaryWrapper>

            {/* Airlines Filter */}
            <ErrorBoundaryWrapper identifier={`airlinesFilter-desktop-SEO-srp`} fallback={null}>
                <SEOAirlineFilter />
            </ErrorBoundaryWrapper>

            {/* Price Range Filter */}
            <ErrorBoundaryWrapper identifier={`priceRangeFilter-desktop-SEO-srp`} fallback={null}>
                <SEOPriceFilter />
            </ErrorBoundaryWrapper>
        </Card>
    )
}

export default SEOFilterWrapper
